import React from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { select } from '@panel/commons/core/themev2';
import Calidad from '@panel/commons/assets/icons/widget-calidad.svg';
import CalidadOk from '@panel/commons/assets/icons/widget-calidad-ok.svg';
import Consultas from '@panel/commons/assets/icons/widget-consultas.svg';
import ConsultasOk from '@panel/commons/assets/icons/widget-consultas-ok.svg';
import Duplicados from '@panel/commons/assets/icons/widget-duplicados.svg';
import DuplicadosOk from '@panel/commons/assets/icons/widget-duplicados-ok.svg';
import Reportes from '@panel/commons/assets/icons/widget-reportes.svg';
import ReportesOk from '@panel/commons/assets/icons/widget-reportes-ok.svg';
import SimpleTooltip from '@panel/commons/lib/Tooltip/SimpleTooltip';

const siteId = process.env.REACT_APP_BUILD_SITE;

const CollapsedWidget = ({ widget, isSelected }) => {
  const { t } = useTranslation();
  const { icon, tooltip, tooltipComplete, notifications, ctaCallback, name } = widget;

  return (
    <Container
      onClick={() => notifications > 0 && ctaCallback()}
      notifications={notifications}
      isSelected={isSelected}
      data-panel={`panel-dashboard-collapsedWidget-${name}`}
    >
      <SimpleTooltip
        position='bottom-center'
        text={t(notifications > 0 ? tooltip : tooltipComplete)}
        dataPanel={`panel-dashboard-tooltip-${name}`}
      >
        <InnerArea>
          <Icon notifications={notifications} widget={icon} data-panel={`panel-dashboard-Icon-${icon}`} />
          {notifications > 0 && (
            <NotificationNumber data-panel={`panel-dashboard-notifications-${name}`}>
              {notifications < 100 ? notifications : '+99'}
            </NotificationNumber>
          )}
        </InnerArea>
      </SimpleTooltip>
    </Container>
  );
};

const Container = styled.div`
  width: 91px;
  height: 38px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-right: 40px;
  :last-of-type {
    margin-right: 0;
  }
  cursor: ${({ notifications }) => (notifications ? 'pointer' : 'auto')};
  background-color: ${({ isSelected }) => (isSelected ? select('middleGray') : 'none')};
  :hover {
    background-color: ${({ notifications }) => (notifications ? select('middleGray') : 'none')};
  }
`;

const InnerArea = styled.div`
  width: 91px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
`;

const WidgetIcons = {
  Calidad,
  CalidadOk,
  Consultas,
  ConsultasOk,
  Duplicados,
  DuplicadosOk,
  Reportes,
  ReportesOk
};

export const Icon = styled.div`
  background-image: ${({ notifications, widget }) => `url(${WidgetIcons[`${widget}${notifications ? '' : 'Ok'}`]})`};
  min-height: 30px;
  min-width: 30px;
  background-size: 30px;
  background-repeat: no-repeat;
  background-position-y: center;
  position: relative;
  ${({ notifications, isOpen }) =>
    notifications > 0 &&
    !isOpen &&
    css`
      :after {
        content: '';
        height: 8px;
        width: 8px;
        display: block;
        position: absolute;
        border-radius: 50%;
        background-color: ${siteId === 'VAMX' ? select('orangeVamx') : select('orange')};
        right: -1px;
        top: 2px;
      }
    `};
  ${({ isOpen, notifications }) =>
    isOpen &&
    css`
      background-size: auto;
      min-width: ${() => (notifications ? '27px' : '33px')};
    `}
`;

const NotificationNumber = styled.div`
  font-family: Hind;
  font-size: 24px;
  font-weight: 700;
  line-height: 31px;
  color: ${select('darkGray')};
`;

export default CollapsedWidget;
